import gql from 'graphql-tag';

export const classifyMutation = gql`
  mutation SnapClassify($input: SnapClassifyInput!) {
    snapClassify(input: $input) {
      images {
        id
        url
        crop {
          left
          top
          width
          height
        }
        predictions {
          condition {
            id
            label
            commonName
            description
            url
            highRisk
            malignancy
            sampleImages {
              title
              imageUrl
              thumbnailUrl
            }
            codes {
              icd
              snomed
              conditionName
            }
            healthPage
            symptoms
          }
          probability
        }
      }
    }
  }
`;
